import { CustomCellRendererProps } from "ag-grid-react";
import { Link } from "react-router-dom";
import { Badge } from "@/lib/shadcn/ui/badge";
import { isDecommissioned } from "./apartments.utils";
import type { ApartmentRow } from "./apartments";

// Cell-renderer components extracted from apartments.tsx so that the page file
// exports only its page component (a file mixing components + plain functions
// breaks React Fast Refresh — react-refresh/only-export-components).

export const ApartmentImageRenderer = (params: CustomCellRendererProps) => (
    <Link to={"/admin/apartments/" + params.data.id}>
        {params.value && <img alt={`${params.data.name} Image`} src={params.value} className="logo" />}
    </Link>
);

export const ApartmentNameLinkRenderer = (params: CustomCellRendererProps<ApartmentRow>) => {
    const decommissioned = params.data ? isDecommissioned(params.data, new Date()) : false;
    return (
        <span className="inline-flex items-center gap-2">
            <Link className="text-blue-900 hover:text-blue-950 hover:underline" to={"/admin/apartments/" + params.data?.id}>
                {params.value}
            </Link>
            {decommissioned && (
                <Badge variant="secondary">
                    Decommissioned
                </Badge>
            )}
        </span>
    );
};
